// src/js/common/gsap.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// すでに登録済みでなければ登録（重複登録を防止）
if (!gsap.core.globals().ScrollTrigger) {
  gsap.registerPlugin(ScrollTrigger);
}

export { gsap, ScrollTrigger };
